import { useState, useCallback } from 'react';
import type { Toast } from '../types';

let toastId = 0;

interface AddOptions {
  /** Inline retry button. Click invokes the handler then dismisses the toast. */
  action?: { label: string; onAction: () => void };
  /** Sticky toasts do not auto-dismiss · user must click the X (or action). */
  sticky?: boolean;
}

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const addToast = useCallback(
    (message: string, type: Toast['type'] = 'info', opts: AddOptions = {}) => {
      const id = String(++toastId);
      const toast: Toast = {
        id,
        message,
        type,
        action: opts.action,
        sticky: opts.sticky,
      };
      setToasts((prev) => [...prev, toast]);
      // Sticky toasts (typically PATCH-failure retry prompts) live until
      // the user dismisses them. Non-sticky default to 4s as before.
      if (!opts.sticky) {
        setTimeout(() => {
          setToasts((prev) => prev.filter((t) => t.id !== id));
        }, 4000);
      }
    },
    [],
  );

  const removeToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return { toasts, addToast, removeToast };
}
